export default {
    columns: [
        {
          type: "NUMERIC",
          desc: "wkt.admin.qbuilder.model.work_place.id.description",//"Código interno",
          label: "wkt.admin.qbuilder.model.work_place.id.text",//"Código",
          field: "id"
        },
        {
          type: "CHARACTER",
          desc: "wkt.admin.qbuilder.model.work_place.name.description",//"Nombre",
          label: "wkt.admin.qbuilder.model.work_place.name.text",//"Nombre",
          field: "name"
        },
     ],
}